import translate from '@/app/utils/translate';

export default (code: string): string => {
  switch (code) {
    case 'INTERNAL_TRAINING_TYPE':
      return translate.t('laInternalTraining');
    case 'EXTERNAL_TRAINING_TYPE':
      return translate.t('laExternalTraining');
    case 'OTHER_TRAINING_TYPE':
      return translate.t('laOtherTraining');
    default:
      return '';
  }
};
